import * as React from 'react';

import classNames from 'classnames';

import type {DisplayOptionEntity} from 'nutshell-core/utils';

import {Avatar} from '../avatar/avatar';
import {Body} from '../typography/body';

import styles from './entity-select-row.module.css';

type Props = {
    entity: DisplayOptionEntity;
    size?: 'mini' | 'normal';
};

export function EntitySelectRow(props: Props) {
    const {entity, size = 'normal'} = props;

    const rowStyleNames = classNames(styles['row'], {
        [styles['row--disabled']]: entity.isDisabled,
        [styles['row--mini']]: size === 'mini',
    });

    return (
        <div className={rowStyleNames}>
            <div className={styles['avatar']}>
                <Avatar
                    avatarUrl={entity.avatarUrl}
                    initials={entity.initials}
                    type={entity.type}
                    size={size === 'mini' ? 24 : 32}
                />
            </div>
            <div className={styles['info']}>
                <span>
                    <Body size='small' isBold={true} wrapAnywhere={true}>
                        {entity.value}
                    </Body>{' '}
                    {entity.isDisabled && entity.disabledText ? (
                        <Body size='small' isItalic={true} wrapAnywhere={true}>
                            ({entity.disabledText})
                        </Body>
                    ) : undefined}
                </span>
                {entity.secondaryInfo ? (
                    <Body
                        size='small'
                        color={entity.type === 'contacts' ? 'plum' : 'person'}
                        wrapAnywhere={true}
                    >
                        {entity.secondaryInfo}
                    </Body>
                ) : undefined}
                {entity.tertiaryInfo ? (
                    <Body size='small' color='light' wrapAnywhere={true}>
                        {entity.tertiaryInfo}
                    </Body>
                ) : undefined}
            </div>
        </div>
    );
}
